module.exports = __webpack_public_path__ + "6e95f3efcaf417c4e3f9e16d54eb0718.jpg";